var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"button clearfix",class:[_vm.typeClass, _vm.variationClass, _vm.orientationClass],attrs:{"id":_vm.id},on:{"click":function($event){return _vm.$emit('change', $event)}}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }